module.exports = {
  answerTimeLimit: [3, 120],
  scoreLimit: [1, 1000000],
  delayAfterUnansweredQuestion: [0, 120],
  delayAfterAnsweredQuestion: [0, 120],
  additionalAnswerWaitWindow: [0, 120],
  maxMissedQuestions: [0, 1000],
  appearanceWeight: [1, 100],
};
